import styled from "styled-components";
import { Box } from "@sproutsocial/seeds-react-box";
import type { TypeBoxProps } from "@sproutsocial/seeds-react-box";
import { container } from "@sproutsocial/seeds-react-mixins";

const StyledContainer = styled(Box)<TypeBoxProps>`
  ${container}
`;

export default StyledContainer;
